import { Drawer } from '../overlay/Drawer';
import { OverlayFilterPill, OverlayFilterPillProps } from './OverlayFilterPill';

export const DrawerFilterPill = (props: OverlayFilterPillProps) => (
  <OverlayFilterPill {...props} content={<Drawer>{props.content}</Drawer>}></OverlayFilterPill>
);
